import { render, staticRenderFns } from "./privateKitchen.vue?vue&type=template&id=8ba4c46c&scoped=true"
import script from "./privateKitchen.vue?vue&type=script&lang=js"
export * from "./privateKitchen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4c46c",
  null
  
)

export default component.exports